import React, { useEffect, useState } from "react"
import { Col, Row, UncontrolledAlert, Spinner } from "reactstrap"
import api from "API/Api"
import { AvForm, AvField, AvRadioGroup, AvRadio } from "availity-reactstrap-validation"
import { Link, useParams } from "react-router-dom"
import PageLoader from "./../../../../assets/loading/pageLoad1.gif"

const EditCompany = () => {
  const { id } = useParams()
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [pageLoad, setPageLoad] = useState(true)
  const [company, setCompany] = useState(null)
  const [states, setStates] = useState([])
  const [districts, setDistricts] = useState([])
  const [taluks, setTaluks] = useState([])
  const [changeLogo, setChangeLogo] = useState(false)
  const [changeSecondaryLogo, setChangeSecondaryLogo] = useState(false)
  const [image, setImage] = useState({ preview: "", raw: "" })
  const [secondaryImage, setSecondaryImage] = useState({ preview: "", raw: "" })
  const [logoError, setLogoError] = useState(false)
  const [secondaryLogoError, setSecondaryLogoError] = useState(false)
  const [loadingDistricts, setLoadingDistricts] = useState(false)
  const [loadingTaluks, setLoadingTaluks] = useState(false)
  const [bankAccounts, setBankAccounts] = useState([])

  useEffect(() => {
    const loadData = async () => {
      try {
        const [compResp, stResp, bankResp] = await Promise.all([
          api.get("company/" + id),
          api.get("states"),
          api.get("company-bank-accounts/" + id)
        ])
        const compData = compResp.data.data?.[0] || compResp.data.data
        setCompany(compData)
        setStates(Array.isArray(stResp.data.data) ? stResp.data.data : stResp.data.data?.data || [])
        const banks = Array.isArray(bankResp.data.data) ? bankResp.data.data : []
        setBankAccounts(banks.length > 0 ? banks : [{ bank_ifsc: "", bank_name: "", bank_branch: "", account_number: "", account_payee_name: "", account_type: "savings", linked_phone: "" }])

        if (compData.state) {
          const dstResp = await api.get("districts/" + compData.state)
          setDistricts(Array.isArray(dstResp.data.data) ? dstResp.data.data : dstResp.data.data?.data || [])
          if (compData.district) {
            const tlkResp = await api.get("taluks/" + compData.district)
            setTaluks(Array.isArray(tlkResp.data.data) ? tlkResp.data.data : tlkResp.data.data?.data || [])
          }
        }
      } catch (e) { console.error(e) }
      setPageLoad(false)
    }
    loadData()
  }, [id])

  const stateChangeHandler = async e => {
    const stateId = e.target.value; setDistricts([]); setTaluks([])
    if (!stateId) return; setLoadingDistricts(true)
    try { const r = await api.get("districts/" + stateId); setDistricts(Array.isArray(r.data.data) ? r.data.data : r.data.data?.data || []) } catch (e) { console.error(e) }
    setLoadingDistricts(false)
  }
  const districtChangeHandler = async e => {
    const districtId = e.target.value; setTaluks([])
    if (!districtId) return; setLoadingTaluks(true)
    try { const r = await api.get("taluks/" + districtId); setTaluks(Array.isArray(r.data.data) ? r.data.data : r.data.data?.data || []) } catch (e) { console.error(e) }
    setLoadingTaluks(false)
  }

  const handleLogoChange = e => {
    if (e.target.files.length) { setImage({ preview: URL.createObjectURL(e.target.files[0]), raw: e.target.files[0] }); setChangeLogo(true) }
  }
  const handleSecondaryLogoChange = e => {
    if (e.target.files.length) { setSecondaryImage({ preview: URL.createObjectURL(e.target.files[0]), raw: e.target.files[0] }); setChangeSecondaryLogo(true) }
  }

  // Bank account helpers
  const addBankRow = () => setBankAccounts([...bankAccounts, { bank_ifsc: "", bank_name: "", bank_branch: "", account_number: "", account_payee_name: "", account_type: "savings", linked_phone: "" }])
  const removeBankRow = (i) => setBankAccounts(bankAccounts.filter((_, idx) => idx !== i))
  const updateBank = (i, field, val) => {
    const updated = [...bankAccounts]; updated[i][field] = val; setBankAccounts(updated)
  }

  const handleValidSubmit = async (event, values) => {
    setLoading(true)
    try {
      const formData = new FormData()
      const allFields = [
        "name", "number", "state", "district", "taluk", "door", "village", "pincode",
        "gstIn", "billingTaxType", "cowMilkText", "buffaloMilkText", "agentCommission",
        "rateChartUpdates", "hideProducerRate", "hideBulkVendorsRate", "showProducerRate",
        "showBulkVendorsRate", "publishCCPurchases", "purchaseHistory", "incentiveChartUpdate",
        "unbilledAdvance", "manualEntries", "vlccCode",
        "hideIncentiveProducers", "hideIncentiveBulkVendors",
        "fullDeductionMaterialAdvances", "enableDeductionsBilling", "sameRateStockMaterials",
        "bankPayeeReference", "shortNumberReports", "mobileMandatoryProducer",
        "mobileMandatoryAgents", "customCowMilkText", "customBuffaloMilkText",
        "customMorningSession", "customEveningSession", "allocateVehicleTo",
        "billingValidateCCSession", "billingValidateVLCCSession"
      ]
      allFields.forEach(f => { if (values[f] !== undefined) formData.append(f, values[f]) })
      if (changeLogo && image.raw) formData.append("logo", image.raw)
      if (changeSecondaryLogo && secondaryImage.raw) formData.append("secondaryLogo", secondaryImage.raw)

      const resp = await api.put("update-company/" + id, formData, { headers: { "Content-Type": "multipart/form-data" } })
      if (resp.data.success) {
        // Save bank accounts
        await api.post("bulk-save-bank-accounts/" + id, { accounts: bankAccounts.filter(a => a.account_number) })
        setSubmitted(true); setTimeout(() => setSubmitted(false), 4000)
      }
    } catch (error) { console.error(error) }
    setLoading(false)
  }

  // Reusable components
  const YesNo = ({ name, label, required, value }) => (
    <div className="mb-3">
      <AvRadioGroup inline name={name} label={label} required={required} errorMessage="Pick one!" value={value}>
        <AvRadio label="Yes" value="yes" /><AvRadio label="No" value="no" />
      </AvRadioGroup>
    </div>
  )

  const SectionHeader = ({ icon, color, title }) => (
    <h6 style={{ color, borderBottom: "2px solid #e2e8f0", paddingBottom: "8px", marginBottom: "16px", marginTop: "16px" }}>
      <i className={`fas ${icon}`}></i> {title}
    </h6>
  )

  const assetsUrl = process.env.REACT_APP_ASSETS_URL || "http://localhost:8000/"

  if (pageLoad) return <div className="pageLoader"><img src={PageLoader} alt="Loading..." /></div>
  if (!company) return <div className="dashBody"><p>Company not found</p></div>

  return (
    <div className="dashBody">
      <div className="font-size-18 mb-0 dashHeader">
        <Row>
          <Col md={6}><h4>Edit Company</h4></Col>
          <Col md={6} style={{ textAlign: "right" }}>
            <Link to="/companies" className="dashBtn"><i className="fas fa-chevron-left"></i> <b>Back</b></Link>
          </Col>
        </Row>
      </div>
      <div className="dashContent">
        <AvForm className="form-horizontal mt-4" onValidSubmit={handleValidSubmit}>

          {/* ─── Section 1: Company Information ─── */}
          <SectionHeader icon="fa-building" color="#6366f1" title="Company Information" />
          <Row>
            <Col md={6}><div className="mb-3"><AvField name="name" label="Company Name *" value={company.name} type="text" required /></div></Col>
            <Col md={6}><div className="mb-3"><AvField name="number" label="Company Number *" value={company.number} type="text" required /></div></Col>
          </Row>

          {/* ─── Section 2: Address ─── */}
          <SectionHeader icon="fa-map-marker-alt" color="#0ea5e9" title="Address Details" />
          <Row>
            <Col md={4}><div className="mb-3">
              <AvField type="select" name="state" label="State" value={String(company.state || "")} onChange={stateChangeHandler}>
                <option value="">Select State</option>
                {states.map((s, i) => <option key={i} value={String(s.id)}>{s.state}</option>)}
              </AvField>
            </div></Col>
            <Col md={4}><div className="mb-3">
              <AvField type="select" name="district" label={<>District {loadingDistricts && <Spinner size="sm" color="primary" className="ms-1" />}</>} value={String(company.district || "")} onChange={districtChangeHandler}>
                <option value="">{loadingDistricts ? "Loading..." : districts.length ? "Select District" : "Select State first"}</option>
                {districts.map((d, i) => <option key={i} value={String(d.id)}>{d.district}</option>)}
              </AvField>
            </div></Col>
            <Col md={4}><div className="mb-3">
              <AvField type="select" name="taluk" label={<>Taluk {loadingTaluks && <Spinner size="sm" color="primary" className="ms-1" />}</>} value={company.taluk || ""}>
                <option value="">{loadingTaluks ? "Loading..." : taluks.length ? "Select Taluk" : "Select District first"}</option>
                {taluks.map((t, i) => <option key={i} value={t.taluk}>{t.taluk}</option>)}
              </AvField>
            </div></Col>
          </Row>
          <Row>
            <Col md={3}><div className="mb-3"><AvField name="door" label="Door No" value={company.door} type="text" /></div></Col>
            <Col md={3}><div className="mb-3"><AvField name="village" label="Village Name" value={company.village} type="text" /></div></Col>
            <Col md={3}><div className="mb-3"><AvField name="pincode" label="Pincode" value={company.pincode} type="text" /></div></Col>
            <Col md={3}><div className="mb-3"><AvField name="gstIn" label="Company GSTIN" value={company.gstIn} type="text" /></div></Col>
          </Row>

          {/* ─── Logos ─── */}
          <Row>
            <Col md={6}>
              <div className="mb-3">
                <p><b>Company Logo</b></p>
                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                  {company.logo && !changeLogo && !logoError && (
                    <img src={assetsUrl + "assets/images/companies/" + company.logo} alt="Logo" width="100" height="100"
                      style={{ borderRadius: "8px", objectFit: "cover", border: "1px solid #e2e8f0" }} onError={() => setLogoError(true)} />
                  )}
                  {image.preview && changeLogo && (
                    <img src={image.preview} alt="New Logo" width="100" height="100"
                      style={{ borderRadius: "8px", objectFit: "cover", border: "1px solid #e2e8f0" }} />
                  )}
                  {(!company.logo || logoError) && !changeLogo && !image.preview && (
                    <div style={{ width: "100px", height: "100px", background: "#f1f5f9", borderRadius: "8px",
                      display: "flex", alignItems: "center", justifyContent: "center", border: "2px dashed #cbd5e1" }}>
                      <i className="fas fa-camera" style={{ fontSize: "24px", color: "#94a3b8" }}></i>
                    </div>
                  )}
                  <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                    {company.logo && !changeLogo && !logoError && (
                      <a href={assetsUrl + "assets/images/companies/" + company.logo} download className="btn btn-outline-primary btn-sm" target="_blank" rel="noreferrer">
                        <i className="fas fa-download me-1"></i> Download
                      </a>
                    )}
                    <label htmlFor="upload-logo" className="btn btn-outline-success btn-sm mb-0" style={{ cursor: "pointer" }}>
                      <i className="fas fa-upload me-1"></i> Upload new
                    </label>
                    {(company.logo || changeLogo) && !logoError && (
                      <button type="button" className="btn btn-outline-danger btn-sm" onClick={() => { setImage({ preview: "", raw: "" }); setChangeLogo(false) }}>
                        <i className="fas fa-times me-1"></i> Remove
                      </button>
                    )}
                  </div>
                </div>
                <input id="upload-logo" type="file" accept=".jpg,.jpeg,.png" style={{ display: "none" }} onChange={handleLogoChange} />
                <small className="text-muted d-block mt-1">Image width not more than 200px</small>
              </div>
            </Col>
            <Col md={6}>
              <div className="mb-3">
                <p><b>Company Secondary Logo</b></p>
                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                  {company.secondaryLogo && !changeSecondaryLogo && !secondaryLogoError && (
                    <img src={assetsUrl + "assets/images/companies/" + company.secondaryLogo} alt="Secondary" width="100" height="100"
                      style={{ borderRadius: "8px", objectFit: "cover", border: "1px solid #e2e8f0" }} onError={() => setSecondaryLogoError(true)} />
                  )}
                  {secondaryImage.preview && changeSecondaryLogo && (
                    <img src={secondaryImage.preview} alt="New Secondary" width="100" height="100"
                      style={{ borderRadius: "8px", objectFit: "cover", border: "1px solid #e2e8f0" }} />
                  )}
                  {(!company.secondaryLogo || secondaryLogoError) && !changeSecondaryLogo && !secondaryImage.preview && (
                    <div style={{ width: "100px", height: "100px", background: "#f1f5f9", borderRadius: "8px",
                      display: "flex", alignItems: "center", justifyContent: "center", border: "2px dashed #cbd5e1" }}>
                      <i className="fas fa-camera" style={{ fontSize: "24px", color: "#94a3b8" }}></i>
                    </div>
                  )}
                  <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                    {company.secondaryLogo && !changeSecondaryLogo && (
                      <a href={assetsUrl + "assets/images/companies/" + company.secondaryLogo} download className="btn btn-outline-primary btn-sm" target="_blank" rel="noreferrer">
                        <i className="fas fa-download me-1"></i> Download
                      </a>
                    )}
                    <label htmlFor="upload-secondary-logo" className="btn btn-outline-success btn-sm mb-0" style={{ cursor: "pointer" }}>
                      <i className="fas fa-upload me-1"></i> Upload new
                    </label>
                    {(company.secondaryLogo || changeSecondaryLogo) && (
                      <button type="button" className="btn btn-outline-danger btn-sm" onClick={() => { setSecondaryImage({ preview: "", raw: "" }); setChangeSecondaryLogo(false) }}>
                        <i className="fas fa-times me-1"></i> Remove
                      </button>
                    )}
                  </div>
                </div>
                <input id="upload-secondary-logo" type="file" accept=".jpg,.jpeg,.png" style={{ display: "none" }} onChange={handleSecondaryLogoChange} />
              </div>
            </Col>
          </Row>

          {/* ─── Section 3: Billing & Tax ─── */}
          <SectionHeader icon="fa-file-invoice" color="#22c55e" title="Billing & Tax" />
          <Row>
            <Col md={4}><div className="mb-3">
              <AvRadioGroup inline name="billingTaxType" label="Company Billing Tax Type *" required errorMessage="Pick one!" value={company.billingTaxType}>
                <AvRadio label="No Tax" value="no tax" /><AvRadio label="GST" value="gst" />
              </AvRadioGroup>
            </div></Col>
            <Col md={4}><div className="mb-3"><AvField name="cowMilkText" label="Cow Milk Text for API" value={company.cowMilkText} type="text" /></div></Col>
            <Col md={4}><div className="mb-3"><AvField name="buffaloMilkText" label="Buffalo Milk Text for API" value={company.buffaloMilkText} type="text" /></div></Col>
          </Row>

          {/* ─── Section 4: App & Rate Settings ─── */}
          <SectionHeader icon="fa-cogs" color="#f59e0b" title="App & Rate Settings" />
          <Row>
            <Col md={6}><YesNo name="agentCommission" label="Agent Commission based on VLCC Quantity *" required value={company.agentCommission} /></Col>
            <Col md={6}><YesNo name="rateChartUpdates" label="Enable Approval for Rate Chart Updates *" required value={company.rateChartUpdates} /></Col>
          </Row>
          <Row>
            <Col md={6}><YesNo name="hideProducerRate" label="Hide Rate for Producers in Farmer App" value={company.hideProducerRate} /></Col>
            <Col md={6}><YesNo name="hideBulkVendorsRate" label="Hide Rate for Bulk Vendors in Farmer App" value={company.hideBulkVendorsRate} /></Col>
          </Row>
          <Row>
            <Col md={6}><YesNo name="showProducerRate" label="Show Net Rate for Producers in Farmer App" value={company.showProducerRate} /></Col>
            <Col md={6}><YesNo name="showBulkVendorsRate" label="Show Net Rate for Bulk Vendors in Farmer App" value={company.showBulkVendorsRate} /></Col>
          </Row>
          <Row>
            <Col md={6}><YesNo name="hideIncentiveProducers" label="Hide Incentive for Producers in Farmer App *" required value={company.hideIncentiveProducers} /></Col>
            <Col md={6}><YesNo name="hideIncentiveBulkVendors" label="Hide Incentive for Bulk Vendors in Farmer App *" required value={company.hideIncentiveBulkVendors} /></Col>
          </Row>
          <Row>
            <Col md={6}><YesNo name="publishCCPurchases" label="Manually Publish CC Purchases to Farmer App for Bulk Vendors" value={company.publishCCPurchases} /></Col>
            <Col md={6}><div className="mb-3"><AvField name="purchaseHistory" label="Number of days of purchase history in Farmer App" type="number" value={company.purchaseHistory} /></div></Col>
          </Row>
          <Row>
            <Col md={6}><YesNo name="incentiveChartUpdate" label="Enable Approval for Incentive Chart Updates" value={company.incentiveChartUpdate} /></Col>
            <Col md={6}><YesNo name="unbilledAdvance" label="Unbilled Advance Available" value={company.unbilledAdvance} /></Col>
          </Row>

          {/* ─── Section 5: Advanced Settings ─── */}
          <SectionHeader icon="fa-sliders-h" color="#8b5cf6" title="Advanced Settings" />
          <Row>
            <Col md={6}><YesNo name="fullDeductionMaterialAdvances" label="Always add full deduction for Material Advances *" required value={company.fullDeductionMaterialAdvances} /></Col>
            <Col md={6}><YesNo name="enableDeductionsBilling" label="Enable deductions for Producer Billing Vendors by Commission *" required value={company.enableDeductionsBilling} /></Col>
          </Row>
          <Row>
            <Col md={6}><YesNo name="sameRateStockMaterials" label="Apply same rate for Stock Materials in CC and VLCC *" required value={company.sameRateStockMaterials} /></Col>
            <Col md={6}><YesNo name="bankPayeeReference" label="Company Bank Payee Reference is required *" required value={company.bankPayeeReference} /></Col>
          </Row>
          <Row>
            <Col md={6}><YesNo name="manualEntries" label="Highlight Edited and Manual Entries" value={company.manualEntries} /></Col>
            <Col md={6}><YesNo name="vlccCode" label="Enable Milktypewise Code for VLCC *" required value={company.vlccCode} /></Col>
          </Row>
          <Row>
            <Col md={6}><YesNo name="shortNumberReports" label="Use Producer Short Number in Listing and Reports" value={company.shortNumberReports} /></Col>
            <Col md={6}><YesNo name="mobileMandatoryProducer" label="Mobile Number is Mandatory for Producer *" required value={company.mobileMandatoryProducer} /></Col>
          </Row>
          <Row>
            <Col md={6}><YesNo name="mobileMandatoryAgents" label="Mobile Number is Mandatory for Agents/Vendors *" required value={company.mobileMandatoryAgents} /></Col>
          </Row>

          {/* ─── Section 6: Custom Labels ─── */}
          <SectionHeader icon="fa-tags" color="#ec4899" title="Custom Labels & Session" />
          <Row>
            <Col md={6}><div className="mb-3">
              <AvField name="customCowMilkText" label="Custom Milk Type Text for Cow Milk" type="text" value={company.customCowMilkText || "CM"} />
              <small className="text-muted">Displayed in Procurement Listing, Reports, Bill Printouts, etc</small>
            </div></Col>
            <Col md={6}><div className="mb-3">
              <AvField name="customBuffaloMilkText" label="Custom Milk Type Text for Buffalo Milk" type="text" value={company.customBuffaloMilkText || "BM"} />
              <small className="text-muted">Displayed in Procurement Listing, Reports, Bill Printouts, etc</small>
            </div></Col>
          </Row>
          <Row>
            <Col md={6}><div className="mb-3">
              <AvField name="customMorningSession" label="Custom Session Text for Morning Session" type="text" value={company.customMorningSession || ""} />
              <small className="text-muted">Displayed in Procurement Listing, Reports, Bill Printouts, etc</small>
            </div></Col>
            <Col md={6}><div className="mb-3">
              <AvField name="customEveningSession" label="Custom Session Text for Evening Session" type="text" value={company.customEveningSession || ""} />
              <small className="text-muted">Displayed in Procurement Listing, Reports, Bill Printouts, etc</small>
            </div></Col>
          </Row>
          <Row>
            <Col md={6}><div className="mb-3">
              <AvRadioGroup inline name="allocateVehicleTo" label="Allocate Pickup Vehicle To *" required errorMessage="Pick one!" value={company.allocateVehicleTo || "1"}>
                <AvRadio label="Routes" value="1" /><AvRadio label="Centers/Vendors" value="2" /><AvRadio label="Manually Select" value="3" />
              </AvRadioGroup>
            </div></Col>
          </Row>

          {/* ─── Section 7: Billing Validations ─── */}
          <SectionHeader icon="fa-check-double" color="#ef4444" title="Billing Validations" />
          <Row>
            <Col md={6}><YesNo name="billingValidateCCSession" label="Billing Validate CC Session Close *" required value={company.billingValidateCCSession} /></Col>
            <Col md={6}><YesNo name="billingValidateVLCCSession" label="Billing Validate VLCC Session Close *" required value={company.billingValidateVLCCSession} /></Col>
          </Row>

          {/* ─── Section 8: Bank Accounts ─── */}
          <SectionHeader icon="fa-university" color="#0d9488" title="Client Company Bank Accounts Information" />
          <div className="table-responsive mb-3">
            <table className="table table-bordered" style={{ fontSize: "13px" }}>
              <thead style={{ background: "#f8fafc" }}>
                <tr>
                  <th>Bank IFSC</th><th>Bank Name</th><th>Bank Branch</th>
                  <th>Account Number *</th><th>Account Payee Name *</th>
                  <th>Account Type *</th><th>Linked Phone</th><th style={{ width: "50px" }}></th>
                </tr>
              </thead>
              <tbody>
                {bankAccounts.map((acc, i) => (
                  <tr key={i}>
                    <td><input className="form-control form-control-sm" value={acc.bank_ifsc || ""} onChange={e => updateBank(i, "bank_ifsc", e.target.value)} placeholder="IFSC" /></td>
                    <td><input className="form-control form-control-sm" value={acc.bank_name || ""} onChange={e => updateBank(i, "bank_name", e.target.value)} placeholder="Bank Name" /></td>
                    <td><input className="form-control form-control-sm" value={acc.bank_branch || ""} onChange={e => updateBank(i, "bank_branch", e.target.value)} placeholder="Branch" /></td>
                    <td><input className="form-control form-control-sm" value={acc.account_number || ""} onChange={e => updateBank(i, "account_number", e.target.value)} placeholder="Account No" required /></td>
                    <td><input className="form-control form-control-sm" value={acc.account_payee_name || ""} onChange={e => updateBank(i, "account_payee_name", e.target.value)} placeholder="Payee Name" required /></td>
                    <td>
                      <div style={{ display: "flex", gap: "8px" }}>
                        <label style={{ fontSize: "12px", display: "flex", alignItems: "center", gap: "3px" }}>
                          <input type="radio" checked={acc.account_type === "savings"} onChange={() => updateBank(i, "account_type", "savings")} /> Savings
                        </label>
                        <label style={{ fontSize: "12px", display: "flex", alignItems: "center", gap: "3px" }}>
                          <input type="radio" checked={acc.account_type === "current"} onChange={() => updateBank(i, "account_type", "current")} /> Current
                        </label>
                      </div>
                    </td>
                    <td><input className="form-control form-control-sm" value={acc.linked_phone || ""} onChange={e => updateBank(i, "linked_phone", e.target.value)} placeholder="Phone" /></td>
                    <td>
                      {bankAccounts.length > 1 && (
                        <button type="button" className="btn btn-outline-danger btn-sm" onClick={() => removeBankRow(i)} title="Remove">
                          <i className="fas fa-times"></i>
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <button type="button" className="btn btn-outline-primary btn-sm" onClick={addBankRow}>
              <i className="fas fa-plus me-1"></i> Add Bank Account
            </button>
          </div>

          {/* Submit */}
          <div className="mb-3 row mt-4">
            <div className="col-6">
              {submitted && <UncontrolledAlert color="success"><strong>Company Updated Successfully!</strong></UncontrolledAlert>}
            </div>
            <div className="col-6 text-end">
              <button className="btn btn-primary w-md waves-effect waves-light" type="submit" disabled={loading}>
                {loading ? <><Spinner size="sm" /><span style={{ paddingLeft: "10px" }}>Updating...</span></> : <span><i className="fas fa-save"></i> Update Company</span>}
              </button>
            </div>
          </div>
        </AvForm>
      </div>
    </div>
  )
}

export default EditCompany
